<template>
  <el-dialog
    class="radish-dia"
    title="批量修改部门"
    top="70px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div>
      <el-select v-model="val" size="mini" filterable>
        <el-option v-for="(op, k) in options" :key="k" :label="op" :value="op"></el-option>
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data: function() {
    return {
      dialogVisible: false,
      val: '',
      options: [],
    }
  },
  methods: {
    show: function(departments, ids) {
      this.val = ''
      this.ids = ids
      this.options = departments
      this.dialogVisible = true
    },
    handleConfirm: function() {
      const val = this.val
      if (val) {
        this.$confirm('批量修改部门', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const result = await app.service('radish').modifyByIds({ ids: this.ids, data: { 部门: val } })
            if (result.status == 'success') {
              await this.onConfirm()
              this.dialogVisible = false
            } else {
              this.$message.error(result.msg)
            }
          })
          .catch(() => {})
      }
    },
  },
}
</script>
